import { Text, View } from 'react-native'
import type { StandingRow } from '../../../src/leagueDetail'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface FormLettersProps {
  row: StandingRow
  styles: LeagueStandingsTableStyles
}

export function FormLetters({ row, styles }: FormLettersProps) {
  return (
    <View style={styles.formLettersRow}>
      {row.form.map((letter, i) => {
        const chipStyle =
          letter === 'W' ? styles.formChipW : letter === 'D' ? styles.formChipD : styles.formChipL
        const chipTextColor =
          letter === 'W'
            ? styles.formChipTextW
            : letter === 'D'
              ? styles.formChipTextD
              : styles.formChipTextL
        return (
          <View key={`${row.teamId}-form-${i}-${letter}`} style={[styles.formChip, chipStyle]}>
            <Text style={[styles.formChipTextBase, chipTextColor]}>{letter}</Text>
          </View>
        )
      })}
    </View>
  )
}
